import {textBlockQuestion} from '@/common/questionsExporter/textBlockQuestion'
import {multipleChoiceQuestion} from '@/common/questionsExporter/multipleChoiceQuestion'
import {matchingQuestion} from '@/common/questionsExporter/matchingQuestion'
import {fillInTheBlankQuestion} from '@/common/questionsExporter/fillInTheBlankQuestion'
import {labelingQuestion} from '@/common/questionsExporter/labelingQuestion'
import {sortingQuestion} from '@/common/questionsExporter/sortingQuestion'
import {groupingQuestion} from '@/common/questionsExporter/groupingQuestion'
import {hotspotQuestion} from '@/common/questionsExporter/hotspotQuestion'

// Converts a list of questions into their plaintext equivalent as one combined string.
const exportQuestions = (questions) => {
    if (!questions || questions.length === 0) {
        return ''
    }

    const mappedQuestions = questions.map((question) => {
        switch (question.type) {
            // these types only have relevant data in the question.content.question field
            case 'text_block':
                return textBlockQuestion(question.content)
            case 'open_response':
                return textBlockQuestion(question.content)
            case 'media_block':
                return textBlockQuestion(question.content)
            case 'true_false':
                return textBlockQuestion(question.content)
            case 'numeric_response':
                return textBlockQuestion(question.content)
            case 'drawing':
                return textBlockQuestion(question.content)

            // these types are all variations on multiple choice
            case 'multiple_choice':
                return multipleChoiceQuestion(question.content)
            case 'new_multiple_choice':
                return multipleChoiceQuestion(question.content, true)
            case 'select_all_that_apply':
                return multipleChoiceQuestion(question.content)
            case 'new_select_all_that_apply':
                return multipleChoiceQuestion(question.content, true)

            case 'matching':
                return matchingQuestion(question.content)
            case 'fill_in_the_blank':
                return fillInTheBlankQuestion(question.content)
            case 'new_fill_in_the_blank':
                return fillInTheBlankQuestion(question.content)
            case 'labeling':
                return labelingQuestion(question.content)
            case 'sorting':
                return sortingQuestion(question.content)
            case 'grouping':
                return groupingQuestion(question.content)
            case 'hot_spot':
                return hotspotQuestion(question.content)


            default:
                return ''
        }
    })

    return mappedQuestions.join("\n\n")
}

export {exportQuestions}
